import React from 'react'

const Alert = React.createClass({
  render() {
    const { classNames, message, type, link, linkText, iconClass, icon } = this.props

    return (
      <div className={`alert alert-${type || 'success'} ${classNames}`} role='alert'>
        {iconClass && (
          <span className={iconClass}>
            {icon}
          </span>
        )}
        {message}
        {(link && linkText) && (
          <div className='mt5'>
            <a href={link} className='alert-link'>{linkText}</a>
          </div>
        )}
      </div>
    )
  }
})

export default Alert
